angular.module('jmsApp', ['rms.common']);